import { type FC } from 'react';
import classnames from 'classnames';
import { PapiGallection } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import FoldersHeader from '../FoldersHeader';
import FolderSlider from '../FolderSlider';
import FolderContent from '../FolderContent';
import GalleryTierUpsellCard from '../GalleryTierUpsellCard';
import { useGalleryTierUpsell } from '../hooks/useGalleryTierUpsell';

import s from './GallectionSimpleView.scss';

export interface Props {
  currentFolder?: PapiGallection;
  hideFolderSlider?: boolean;
}

const DesktopGallectionSimpleView: FC<Props> = ({
  currentFolder,
  hideFolderSlider,
}) => {
  const mindTheGap = useFlag('mind_the_gap');
  const { showTierUpsell, tierCount, promoDeviation } =
    useGalleryTierUpsell();

  const renderSliderArea = () => {
    return (
      <div
        className={classnames(
          s['folders-and-ad'],
          mindTheGap && s['mind-the-gap']
        )}
      >
        <FoldersHeader />
        <div className={s['slider-row']}>
          {!hideFolderSlider && <FolderSlider />}
          {showTierUpsell && (
            <GalleryTierUpsellCard
              tierCount={tierCount}
              promoDeviation={promoDeviation}
            />
          )}
        </div>
      </div>
    );
  };
  return (
    <div id="content" className={s['root']}>
      <ErrorBoundary debugComponent="DesktopGallectionSimpleView">
        {renderSliderArea()}
        <div id="sub-folder-gallery">
          {currentFolder && (
            <FolderContent
              key={currentFolder?.folderId}
              folderId={currentFolder?.folderId || 0}
            />
          )}
        </div>
      </ErrorBoundary>
    </div>
  );
};
DesktopGallectionSimpleView.displayName = 'DesktopGallectionSimpleView';

export default DesktopGallectionSimpleView;
